<template>
    <icon-menu bottom left offset-y nudge-left="12" nudge-top="8">
      <template slot="icon-menu-list">
          <div @click="$emit('copy-interface')" class="icon-menu__item">
            Duplicate<apio-icon
              name="ui-copy"
              size="16"
              class="ml-4 icon-menu-item__icon"
              
            />
          </div>
          <div @click="$emit('edit-build')" class="icon-menu__item">
            Edit build<apio-icon
              name="ui-edit"
              size="16"
              class="ml-4 icon-menu-item__icon"
            />
          </div>

          <div @click="$emit('save-as-recipe')" class="icon-menu__item">
            Save as recipe<apio-icon
              name="ui-save"
              size="16"
              class="ml-4 icon-menu-item__icon"
              
            />
          </div>

          <hr class="mb-2">
          <div @click="$emit('delete-interface')" class="icon-menu__item">
            Delete interface<apio-icon
              name="ui-trash"
              size="16"
              class="ml-4 icon-menu__icon"
            />
          </div>
          <!-- <div @click="$emit('remove-interface-from-group')" class="icon-menu__item">
            Remove from group<apio-icon
              name="ui-trash"
              size="16"
              class="ml-4 icon-menu-item__icon"
              
            />
          </div> -->
      </template>
  </icon-menu>
</template>

<script>
export default {
  components: {
    IconMenu: () => import("@/components/Misc/IconMenu.vue"),
  }
};
</script>
